import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup
} from '@angular/forms';

@Component({
  selector: 'date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss']
})
export class DatePickerComponent implements OnInit {
  formGroup: UntypedFormGroup;

  @Input()
  public title: string;
  @Input()
  public placeholder: string;
  @Output()
  public answer = new EventEmitter();

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit() {
    this.formGroup = this.initDatePickerForm();
  }

  initDatePickerForm() {
    return this.formBuilder.group({
      answer: new UntypedFormControl('')
    });
  }

  answered(value) {
    this.answer.emit(value);
  }
}
